import React from 'react';
import cn from 'classnames';
import _isFunction from 'lodash/isFunction';
import styles from './index.module.scss';

import { UiKit } from 'components';
import { If } from 'utils';
import { useModal } from '../context.js';

/**
 * @param {Object} props
 * @param {() => void} props.onConfirm
 * @param {import('utils/types').SizeVariant} props.btnSize
 * @param {boolean} props.isDisabled
 * @param {boolean} props.hideCancelBtn
 * @param {boolean} props.forceShowConfirmBtn
 * @param {string} props.cancelBtnText
 * @param {string} props.confirmBtnText
 * @param {string} props.confirmBtnVariant
 * @param {string} props.className
 * @param {string} props.cancelBtnClassName
 * @param {string} props.confirmBtnClassName
 * @param {React.ReactNode} props.children
 */
export default function ModalFooter({
  onConfirm,
  btnSize = 'md',
  isDisabled = false,
  hideCancelBtn = false,
  forceShowConfirmBtn = false,
  cancelBtnText = 'Cancel',
  confirmBtnText = 'Confirm',
  confirmBtnVariant = 'primary',
  className = '',
  cancelBtnClassName = '',
  confirmBtnClassName = '',
  children = null
}) {
  const { isProcessing, onClose } = useModal();

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.content}>{children}</div>
      <div className={styles.actions}>
        <If test={!hideCancelBtn}>
          <UiKit.Button
            type="button"
            size={btnSize}
            variant="outline"
            onClick={onClose}
            disabled={isProcessing}
            className={cancelBtnClassName}
          >
            {cancelBtnText}
          </UiKit.Button>
        </If>
        <If test={_isFunction(onConfirm) || forceShowConfirmBtn}>
          <UiKit.Button
            type="submit"
            size={btnSize}
            variant={confirmBtnVariant}
            onClick={onConfirm}
            disabled={isDisabled}
            processing={isProcessing}
            className={confirmBtnClassName}
          >
            {confirmBtnText}
          </UiKit.Button>
        </If>
      </div>
    </div>
  );
}
